import React from "react";
import { useHistory } from "react-router";
import { openCreatorContentMonitorPreview } from "src/app/components/CreatorContentMonitorPane/methods";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import TooltipPortal from "src/app/components/TooltipPortal/TooltipPortal";
import { CcmStatus } from "src/app/Task/Subtask/Subtask";

import { ReactComponent as LinkIcon } from "src/images/share-alt.svg";
import { ReactComponent as WarningIcon } from "src/images/warning-gray.svg";

import "./ContentMonitorScore.scss";

interface Props {
  creatorId: string;
  monitorId: string;
  value: number | string | null;
  projectId: string;
  status?: CcmStatus;
  tooltip?: string;
}

export const ContentMonitorScore = (props: Props) => {
  const { creatorId, monitorId, value, projectId, status, tooltip } = props;

  const history = useHistory();

  const displayLink = Number(value) > 0;
  const displayStatus = status === "incomplete" && Boolean(tooltip);

  return (
    <div className="content-monitor-score">
      <span className="content-monitor-score__row">
        <span className="content-monitor-score__value">{value}</span>

        {displayLink && (
          <span
            className="content-monitor-score__link"
            onClick={() =>
              openCreatorContentMonitorPreview(
                history,
                monitorId,
                creatorId,
                projectId,
              )
            }
            role="presentation"
          >
            <LinkIcon />
          </span>
        )}
      </span>

      {displayStatus && (
        <TooltipPortal
          className="content-monitor-score__status-tooltip"
          content={tooltip}
        >
          <span className="content-monitor-score__status" role="presentation">
            <WarningIcon />
            <IDHFormattedMessage
              id="ws_content_monitor_incomplete"
              defaultMessage="Incomplete"
            />
          </span>
        </TooltipPortal>
      )}
    </div>
  );
};
